import { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { UnregisterCallback } from 'history'
import confirmService from '../services/confirm.service'

interface HistoryListenerProps extends RouteComponentProps {}

class HistoryListener extends Component<HistoryListenerProps> {
  unlistenHistory: UnregisterCallback | null = null

  handleHistoryChange () {
    this.unlistenHistory = this.props.history.listen(() => {
      confirmService.cancel()
    })
  }

  componentWillUnmount () {
    if (this.unlistenHistory) this.unlistenHistory()
  }

  componentDidMount () {
    this.handleHistoryChange()
  }

  render () {
    return null
  }
}

export default withRouter(HistoryListener)
